import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { LnChevronDownSvgIconComponent } from '../svg-icons/ln-chevron-down-svg-icon/ln-chevron-down-svg-icon.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-acordeon-paragraph',
  imports: [LnChevronDownSvgIconComponent, NgClass],
  templateUrl: './ln-acordeon-paragraph.component.html',
  styleUrl: './ln-acordeon-paragraph.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnAcordeonParagraphComponent {
  @Input() tittle = '';
  expanded = signal(true);

  ToggleExpanded() {
    this.expanded.set(!this.expanded());
  }
}
